import { useMutation } from "@tanstack/react-query";
import apiHandler from "../services/apiServices";
import { useOrganization } from "./useOrganization";
import { toast } from 'react-toastify';
import { queryClient } from '../lib/react-query';

export function usePayment() {
  const { organization } = useOrganization();

  const createCheckout = useMutation({
    mutationFn: async (plan: string) => {
      const response = await apiHandler.post("/payment/create-checkout", {
        plan: plan
      });
      return response.data;
    },
    onSuccess: (data) => {
      window.location.href = data.checkout_url;
    },
  });


  return {
    createCheckout: createCheckout.mutate,
    isCreatingCheckout: createCheckout.isPending,
    processingPlanId: createCheckout.variables,
    currentPlan: organization?.current_plan || 'free',
  };
} 